module.exports = __webpack_public_path__ + "img/GS_Profile-Eva Kedimotse.e8282b21.png";